// Chargebee.init returns the live instance, or creates a new one when a
// Turbolinks page change has removed the old instance's container
export function chargebeeInstance(site) {
  return Chargebee.init({ site });
}
